import React from 'react'
import './footer.scss'
function FooterComponent() {
	return (
		<footer className="bg-dark  text-light mt-5 footerfixed">
			<div className="d-flex align-items-center text-sm justify-content-center">Powered By :
				<img className='brand-img2' height='30px' src="https://parkengage.com/static/media/logo.8ed76367.svg" />
			</div>
		</footer>
	)
}
export default FooterComponent
